import api from './api';
import { toast } from 'sonner';

export const createCheckoutSession = async (plan = 'pro') => {
  try {
    // Create checkout session for specified plan
    const response = await api.post('/create-checkout-session', { plan });
    const { checkout_url } = response.data;
    
    // Redirect to Stripe checkout
    window.location.href = checkout_url;
  } catch (error) {
    console.error('Checkout error:', error);
    const message = error.response?.data?.detail || 'Failed to start checkout. Please try again.';
    toast.error(message);
  }
};

export const createPortalSession = async () => {
  try {
    const response = await api.post('/create-portal-session');
    const { portal_url } = response.data;
    
    // Redirect to Stripe billing portal
    window.location.href = portal_url;
  } catch (error) {
    console.error('Portal error:', error);
    const errorMessage = error.response?.data?.detail || 'Failed to open billing portal.';
    toast.error(errorMessage);
    throw error;
  }
};

// PayGBot Plans
export const PLANS = {
  starter: {
    name: 'Starter',
    price: '$29/month',
    trialDays: 0,
    videoLimit: 0,
  },
  pro: {
    name: 'Pro',
    price: '$79/month',
    trialDays: 7,
    videoLimit: 10,
  },
  elite: {
    name: 'Elite',
    price: '$199/month',
    trialDays: 7,
    videoLimit: 30,
  },
};
